import React, { useState, useEffect, useMemo } from 'react';

import AuthUser from '../AuthUser';
import { getDetalleCobranzasSupervisor2 } from '../../api/requestSupervisor';
import { CobranzasGerenciaXLS } from '../../views/XLS/CobranzasGerenciaXLS';

export const CobranzasGerencia2 = ({ mes, año, supervisor }) => {
  const { user } = AuthUser();
  const [loading, setLoading] = useState(true);
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [result, setResult] = useState([]); // <-- array

  const [searchTerm, setSearchTerm] = useState('');
  const [dateFrom, setDateFrom] = useState(''); // yyyy-mm-dd
  const [dateTo, setDateTo] = useState('');     // yyyy-mm-dd

  // ordenamiento
  const [sortField, setSortField] = useState('FechaDocumento'); // 'FechaDocumento' o 'nombrecli'
  const [sortDir, setSortDir] = useState('desc'); // 'asc' | 'desc'

  // Resetea filtros cuando cambia mes/año para evitar datos residuales
  useEffect(() => {
    setSearchTerm('');
    setDateFrom('');
    setDateTo('');
    setSortField('FechaDocumento');
    setSortDir('desc');
  }, [mes, año, supervisor]);

  useEffect(() => {
    switch (mes) {
      case "Enero":
        setFechaInicio(`${año}-01-01 00:00:00`)
        setFechaFin(`${año}-01-31 23:59:59`)
        break;
      case "Febrero":
        setFechaInicio(`${año}-02-01 00:00:00`)
        setFechaFin(`${año}-02-29 23:59:59`)
        break;
      case "Marzo":
        setFechaInicio(`${año}-03-01 00:00:00`)
        setFechaFin(`${año}-03-31 23:59:59`)
        break;
      case "Abril":
        setFechaInicio(`${año}-04-01 00:00:00`)
        setFechaFin(`${año}-04-30 23:59:59`)
        break;
      case "Mayo":
        setFechaInicio(`${año}-05-01 00:00:00`)
        setFechaFin(`${año}-05-31 23:59:59`)
        break;
      case "Junio":
        setFechaInicio(`${año}-06-01 00:00:00`)
        setFechaFin(`${año}-06-30 23:59:59`)
        break;
      case "Julio":
        setFechaInicio(`${año}-07-01 00:00:00`)
        setFechaFin(`${año}-07-31 23:59:59`)
        break;
      case "Agosto":
        setFechaInicio(`${año}-08-01 00:00:00`)
        setFechaFin(`${año}-08-31 23:59:59`)
        break;
      case "Septiembre":
        setFechaInicio(`${año}-09-01 00:00:00`)
        setFechaFin(`${año}-09-30 23:59:59`)
        break;
      case "Octubre":
        setFechaInicio(`${año}-10-01 00:00:00`)
        setFechaFin(`${año}-10-31 23:59:59`)
        break;
      case "Noviembre":
        setFechaInicio(`${año}-11-01 00:00:00`)
        setFechaFin(`${año}-11-30 23:59:59`)
        break;
      case "Diciembre":
        setFechaInicio(`${año}-12-01 00:00:00`)
        setFechaFin(`${año}-12-31 23:59:59`)
        break;
      default:
        setFechaInicio(`${año}-01-01 00:00:00`)
        setFechaFin(`${año}-01-31 23:59:59`)
        break;
    }
  }, [mes, año]);
  useEffect(() => {
    if (fechaInicio && fechaFin) {
      loadDetalle(fechaInicio, fechaFin);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fechaInicio, fechaFin, supervisor]);

  const loadDetalle = async (startDate, endDate) => {
    setLoading(true);
    try {
      // Si se envió supervisor desde el padre, lo usamos; si no, fallback a datos del user (si es aplicable)
      const supervisorToSend = supervisor || user?.CodSupervisor || user?.CodVendedor || '';

      const resp = await getDetalleCobranzasSupervisor2(supervisorToSend, startDate, endDate);
      // Normaliza posible estructura { data: [...] } u array directo
      const data = Array.isArray(resp) ? resp : (Array.isArray(resp?.data) ? resp.data : []);
      setResult(data);
    } catch (err) {
      console.error('Error cargando detalle cobranzas:', err);
      setResult([]);
    } finally {
      setLoading(false);
    }
  };

  const filteredAndSorted = useMemo(() => {
    if (!Array.isArray(result)) return [];

    const term = (searchTerm || '').trim().toLowerCase();

    let filtered = result.filter(item => {
      // Filtrar por nombre cliente, vendedor o documento (incluye)
      const nombrecli = (item.nombrecli || '').toString().toLowerCase();
      const vendedor = (item.Nombre || item.CodVendedor || '').toString().toLowerCase();
      const documento = (item.documento || '').toString().toLowerCase();

      const matchesText = !term || nombrecli.includes(term) || vendedor.includes(term) || documento.includes(term);

      // Filtrar por rango de fecha si dateFrom/dateTo están definidos
      let matchesDate = true;
      if (dateFrom) {
        const docDate = new Date(item.FechaDocumento);
        const from = new Date(dateFrom + 'T00:00:00');
        if (isNaN(docDate)) matchesDate = false;
        else matchesDate = docDate >= from;
      }
      if (matchesDate && dateTo) {
        const docDate = new Date(item.FechaDocumento);
        const to = new Date(dateTo + 'T23:59:59');
        if (isNaN(docDate)) matchesDate = false;
        else matchesDate = docDate <= to;
      }

      return matchesText && matchesDate;
    });

    // Sorting
    filtered.sort((a, b) => {
      if (sortField === 'FechaDocumento') {
        const da = new Date(a.FechaDocumento);
        const db = new Date(b.FechaDocumento);
        if (isNaN(da) || isNaN(db)) return 0;
        return sortDir === 'asc' ? da - db : db - da;
      } else if (sortField === 'nombrecli') {
        const na = (a.nombrecli || '').toString().toLowerCase();
        const nb = (b.nombrecli || '').toString().toLowerCase();
        if (na < nb) return sortDir === 'asc' ? -1 : 1;
        if (na > nb) return sortDir === 'asc' ? 1 : -1;
        return 0;
      }
      return 0;
    });

    return filtered;
  }, [result, searchTerm, dateFrom, dateTo, sortField, sortDir]);

  return (
    <>
      <h4 className='text-belmeny text-center my-2'>
        Documentos pendientes de {mes} del año {año}
        <span className='float-end'>
          <CobranzasGerenciaXLS data={filteredAndSorted} mes={mes} año={año} />
        </span>
      </h4>

      {/* CONTROLES DE FILTRO */}
      <div className="row mb-3">
        <div className="col-md-4 mb-2">
          <input
            type="text"
            className="form-control"
            placeholder="Buscar por cliente, vendedor o documento..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="col-auto mb-2">
          <input type="date" className="form-control" value={dateFrom} onChange={e => setDateFrom(e.target.value)} />
        </div>
        <div className="col-auto mb-2">
          <input type="date" className="form-control" value={dateTo} onChange={e => setDateTo(e.target.value)} />
        </div>

        <div className="col-auto d-flex align-items-center mb-2">
          <label className="me-2">Ordenar:</label>
          <select className="form-select me-2" value={sortField} onChange={e => setSortField(e.target.value)}>
            <option value="FechaDocumento">Fecha</option>
            <option value="nombrecli">Cliente</option>
          </select>
          <button className="btn btn-outline-secondary" onClick={() => setSortDir(d => d === 'asc' ? 'desc' : 'asc')}>
            {sortDir === 'asc' ? 'Asc' : 'Desc'}
          </button>
        </div>

        <div className="col-auto ms-auto mb-2">
          <button className="btn btn-sm btn-link" onClick={() => { setSearchTerm(''); setDateFrom(''); setDateTo(''); setSortField('FechaDocumento'); setSortDir('desc'); }}>
            Limpiar filtros
          </button>
        </div>
      </div>

      {/* CABECERAS */}
      <div className="row bg-belmeny3 text-white py-3 rounded">
        <div className="col d-flex flex-column justify-content-center"><h5 className="text-uppercase text-center">Zona</h5></div>
        <div className="col d-flex flex-column justify-content-center"><h5 className="text-uppercase text-center">Documento</h5></div>
        <div className="col-3 d-flex flex-column justify-content-center"><h5 className="text-uppercase text-center">Cliente</h5></div>
        <div className="col d-flex flex-column justify-content-center"><h5 className="text-uppercase text-center">Vendedor</h5></div>
        <div className="col d-flex flex-column justify-content-center"><h5 className="text-uppercase text-center">Emisión</h5></div>
        <div className="col d-flex flex-column justify-content-center"><h5 className="text-uppercase text-center">Dia(s) vencido(s)</h5></div>
        <div className="col d-flex flex-column justify-content-center"><h5 className="text-uppercase text-center">Dias de crédito</h5></div>
        <div className="col d-flex flex-column justify-content-center"><h5 className="text-uppercase text-center">Monto facturado</h5></div>
        <div className="col d-flex flex-column justify-content-center"><h5 className="text-uppercase text-center">Monto pendiente</h5></div>
        <div className="col d-flex flex-column justify-content-center"><h5 className="text-uppercase text-center">Estado</h5></div>
      </div>

      {loading ? (
        <div className="text-center my-4">Cargando cobranzas...</div>
      ) : (
        <>
          <div className="mb-2 text-muted">Resultados: {filteredAndSorted.length}</div>
          {filteredAndSorted.length === 0 && <div className="text-center text-muted">No hay resultados.</div>}
          {filteredAndSorted.map((item, idx) => {
            // key estable: documento si existe, si no fallback compuesto
            const key = item.documento ? item.documento : `${item.CodVendedor || 'v'}-${item.FechaDocumento || 'f'}-${idx}`;
            return (
              <React.Fragment key={key}>
                <div className="row text-center my-2">
                  <div className="col"><h5>{item.Sector}</h5></div>
                  <div className="col"><h5 className='text-danger'>{item.documento}</h5></div>
                  <div className="col-3"><h5>{item.nombrecli}</h5></div>
                  <div className="col"><h5>{item.CodVendedor} - {item.Nombre}</h5></div>
                  <div className="col"><h5>{item.FechaDocumento ? new Date(item.FechaDocumento).toLocaleDateString('es-MX') : ''}</h5></div>
                  <div className="col"><h5>{item.DiasVencidos} día(s)</h5></div>
                  <div className="col"><h5>{item.DiasCredito} día(s)</h5></div>
                  <div className="col"><h5 className='text-success'>{Number(item.TotalFact).toFixed(2)} USD</h5></div>
                  <div className="col"><h5 className='text-danger'>{Number(item.TotalPend).toFixed(2)} USD</h5></div>
                  <div className="col">
                    <h5>
                      {(item.Estatus === 0 || Number(item.TotalFact) === Number(item.TotalPend))
                        ? <span className='text-danger'>Pendiente</span>
                        : <span className='text-info'>Con abono</span>}
                    </h5>
                  </div>
                </div>
                <div className="division w-100 my-2 bg-belmeny3"></div>
              </React.Fragment>
            );
          })}
        </>
      )}
    </>
  );
};
